import { render, staticRenderFns } from "./LayoutCentered.vue?vue&type=template&id=53a8bf92&lang=pug"
import script from "./LayoutCentered.vue?vue&type=script&lang=js"
export * from "./LayoutCentered.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports